// extracted by mini-css-extract-plugin
export var thankYouContainer = "ThankYou-module--thankYouContainer--29vV9";
export var header = "ThankYou-module--header--2Dyp7";
export var blueLink = "ThankYou-module--blueLink--gQ3Nq";
export var links = "ThankYou-module--links--2aaGF";
export var linkItem = "ThankYou-module--linkItem--2wlxu";
export var imageContainer = "ThankYou-module--imageContainer--1nZC3";
export var image = "ThankYou-module--image--NPRCX";
export var link = "ThankYou-module--link--2RcEh";
export var icon = "ThankYou-module--icon--39J8_";